<div class="d-block chart-cover">
    <canvas #chartElem 
      baseChart
      width="400" 
      height="400"
      [type]="'line'"
      [data]="lineChartData"
      [options]="lineChartOptions"
      [legend]="lineChartLegend">
    </canvas>
    <button *ngIf="enableSaveBtn" (click)="saveCanvas()" class="btn-brand-main klaim_btn text-center download-btn">
      <i class="kennedys-icon kennedys-icon-download"></i>
    </button>
  </div>
  